<div class="fin-dash">

  <!-- Page Header -->
  <div class="fin-dash__header">
    <div class="fin-dash__header-left">
      <span class="fin-dash__title">Welcome back, {{ currentUser?.username || 'Sys Admin' }}</span>
    </div>
    <div class="fin-dash__header-right">
      <div class="fin-dash__period-selector">
        <button
          class="fin-dash__period-btn"
          *ngFor="let p of periods"
          [class.fin-dash__period-btn--active]="activePeriod === p"
          (click)="setPeriod(p)">
          {{ p }}
        </button>
      </div>
      <div class="fin-dash__last-updated">
        <mat-icon>schedule</mat-icon>
        <span>Updated {{ lastUpdated }}</span>
      </div>
    </div>
  </div>

  <!-- KPI Cards Row -->
  <div class="fin-dash__kpi-grid">
    <div class="fin-dash__kpi-card" *ngFor="let kpi of kpiCards" [ngClass]="'fin-dash__kpi-card--' + kpi.variant">
      <div class="fin-dash__kpi-icon">
        <mat-icon>{{ kpi.icon }}</mat-icon>
      </div>
      <div class="fin-dash__kpi-body">
        <p class="fin-dash__kpi-label">{{ kpi.label }}</p>
        <p class="fin-dash__kpi-value">{{ kpi.value }}</p>
        <div class="fin-dash__kpi-change" [ngClass]="kpi.changePositive ? 'positive' : 'negative'">
          <mat-icon>{{ kpi.changePositive ? 'trending_up' : 'trending_down' }}</mat-icon>
          <span>{{ kpi.change }} vs last semester</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content Grid -->
  <div class="fin-dash__content-grid">

    <!-- Fee Collection Status -->
    <div class="fin-dash__card fin-dash__card--collections">
      <div class="fin-dash__card-header">
        <h2 class="fin-dash__card-title">
          <mat-icon>payments</mat-icon> Fee Collection Status
        </h2>
        <button mat-button class="fin-dash__view-all" routerLink="/fee-management">View All</button>
      </div>
      <div class="fin-dash__collection-list">
        <div class="fin-dash__collection-item" *ngFor="let item of collectionItems">
          <div class="fin-dash__collection-info">
            <span class="fin-dash__collection-name">{{ item.name }}</span>
            <span class="fin-dash__collection-meta">{{ item.collected }} / {{ item.total }}</span>
          </div>
          <div class="fin-dash__progress-wrap">
            <div class="fin-dash__progress-bar">
              <div
                class="fin-dash__progress-fill"
                [style.width.%]="item.percent"
                [ngClass]="'fill--' + item.color">
              </div>
            </div>
            <span class="fin-dash__progress-pct">{{ item.percent }}%</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Recent Transactions -->
    <div class="fin-dash__card fin-dash__card--transactions">
      <div class="fin-dash__card-header">
        <h2 class="fin-dash__card-title">
          <mat-icon>receipt_long</mat-icon> Recent Transactions
        </h2>
        <button mat-button class="fin-dash__view-all" routerLink="/student-accounts">View All</button>
      </div>
      <div class="fin-dash__table-wrap">
        <table class="fin-dash__table">
          <thead>
            <tr>
              <th>Student</th>
              <th>Type</th>
              <th>Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tx of recentTransactions">
              <td>
                <div class="fin-dash__tx-student">
                  <div class="fin-dash__avatar">{{ tx.initials }}</div>
                  <div>
                    <p class="fin-dash__tx-name">{{ tx.name }}</p>
                    <p class="fin-dash__tx-id">{{ tx.studentId }}</p>
                  </div>
                </div>
              </td>
              <td><span class="fin-dash__tx-type">{{ tx.type }}</span></td>
              <td class="fin-dash__tx-amount">GH₵ {{ tx.amount | number:'1.2-2' }}</td>
              <td>
                <span class="fin-dash__badge" [ngClass]="'badge--' + tx.status.toLowerCase()">
                  {{ tx.status }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Quick Actions -->
    <div class="fin-dash__card fin-dash__card--actions">
      <div class="fin-dash__card-header">
        <h2 class="fin-dash__card-title">
          <mat-icon>bolt</mat-icon> Quick Actions
        </h2>
      </div>
      <div class="fin-dash__actions-grid">
        <button class="fin-dash__action-btn" *ngFor="let action of quickActions" (click)="navigateTo(action.route)">
          <mat-icon>{{ action.icon }}</mat-icon>
          <span>{{ action.label }}</span>
        </button>
      </div>
    </div>

    <!-- Outstanding Balances -->
    <div class="fin-dash__card fin-dash__card--balances">
      <div class="fin-dash__card-header">
        <h2 class="fin-dash__card-title">
          <mat-icon>account_balance_wallet</mat-icon> Outstanding Balances
        </h2>
        <button mat-button class="fin-dash__view-all" routerLink="/student-accounts">Manage</button>
      </div>
      <div class="fin-dash__balance-summary">
        <div class="fin-dash__balance-stat" *ngFor="let stat of balanceStats">
          <p class="fin-dash__balance-label">{{ stat.label }}</p>
          <p class="fin-dash__balance-value" [ngClass]="stat.urgent ? 'urgent' : ''">{{ stat.value }}</p>
          <p class="fin-dash__balance-sub">{{ stat.sub }}</p>
        </div>
      </div>
      <div class="fin-dash__overdue-list">
        <div class="fin-dash__overdue-item" *ngFor="let o of overdueList">
          <div class="fin-dash__overdue-info">
            <span class="fin-dash__overdue-name">{{ o.name }}</span>
            <span class="fin-dash__overdue-days">{{ o.daysOverdue }} days overdue</span>
          </div>
          <span class="fin-dash__overdue-amount">GH₵ {{ o.amount | number:'1.0-0' }}</span>
        </div>
      </div>
    </div>

  </div>
</div>